import { createI18n } from 'vue-i18n'
// import { usePortalStore } from '@/stores/portal.store'
import { setAcceptLanguageHeader } from '@/apis/http.api'
import { nextTick } from 'vue'
import deMessages from '@/assets/lang/de.json'
import itMessages from '@/assets/lang/it.json'
import frMessages from '@/assets/lang/fr.json'
import esMessages from '@/assets/lang/es.json'
import nlMessages from '@/assets/lang/nl.json'

import { locale, loadMessages } from 'devextreme/localization'

loadMessages(deMessages)
loadMessages(itMessages)
loadMessages(frMessages)
loadMessages(esMessages)
loadMessages(nlMessages)

const i18n = createI18n({
  legacy: false, // you must set `false`, to use Composition API
  locale: window.navigator.language || window.config.DEFAULT_LANGUAGE, // set locale
  fallbackLocale: 'en-US', // set fallback locale
  messages: {
    'en-US': {
      'common.version': 'Version',
    }
  },
})

export const updateLocaleAsync = async(localeId, localizations) => {
  Object.keys(localizations).forEach(language => {
    const langDict = {}
    if (localizations[language] && Array.isArray(localizations[language])) {
      localizations[language]?.forEach(localization => {
        langDict[localization.key] = localization.value
      })
    }
    i18n.global.setLocaleMessage(language, langDict)
  })

  locale(localeId)

  setAcceptLanguageHeader(localeId)
  i18n.global.locale.value = localeId

  return nextTick()
}

export const paramsSubstituteTranslate = (message, params = [], plural = null) => {
  let messageTranslated = plural === null ? i18n.global.t(message, params) : i18n.global.t(message, params, plural)
  const re = new RegExp(`\n`, 'g')
  messageTranslated = messageTranslated.replace(re, '<br/>')
  return messageTranslated
}

export const getTranslatedField = (item, field, languageCode = i18n.global.locale.value) => {
  if (!item.translations) {
    return item[field]
  }
  const currentTranslation = findTranslation(item.translations, languageCode) || findTranslation(item.translations, i18n.global.fallbackLocale.value)
  return currentTranslation?.[field] || item[field]
}

const findTranslation = (translations, languageCode) => {
  if (translations[languageCode]) return translations[languageCode]
  const normalizedCode = languageCode?.toLowerCase()
  const matchingCode = Object.keys(translations).find(code => code.toLowerCase() === normalizedCode)
  return matchingCode ? translations[matchingCode] : undefined
}

export const getTranslatedItems = (items, languageCode = i18n.global.locale.value) => {
  return items && items.map((item) => {
    return {
      ...item,
      name: getTranslatedField(item, 'name', languageCode)
    }
  })
}

export const getLocalizedItems = (items) => {
  return items.map((item) => {
    return {
      ...item,
      name: i18n.global.t(item.name)
    }
  })
}

export const getLocalizedEnumItems = (enumObject, labelPrefix) => getLocalizedItems(Object.keys(enumObject).map(key => ({ id: enumObject[key], name: `${labelPrefix}.${key.toLowerCase()}` })))

// te() walks dotted paths, so it misses the flat dotted keys the server localizations are stored under.
export const translateOrDefault = (key, fallback = key) => {
  const { locale, fallbackLocale } = i18n.global
  const exists = [locale.value, fallbackLocale.value].some(language => i18n.global.getLocaleMessage(language)?.[key] !== undefined)
  return exists ? i18n.global.t(key) : fallback
}

export const getI18n = () => i18n.global

export default i18n
